import { render, staticRenderFns } from "./Sliders.vue?vue&type=template&id=b57def52&scoped=true"
import script from "./Sliders.vue?vue&type=script&lang=js"
export * from "./Sliders.vue?vue&type=script&lang=js"
import style0 from "./Sliders.vue?vue&type=style&index=0&id=b57def52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57def52",
  null
  
)

export default component.exports